import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import { styled } from '@mui/styles';
import { Box, Button, darken } from '@mui/material';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { telNoFormats } from '../../common/util';

const StyledTable = styled(Table)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const TableBox = styled(Box)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const TablePaper = styled(Paper)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
}));

const SPSupplyTable = () => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const { robots, institution } = useSelector((state) => state.dashboard);
  const [ws, setData] = useState([]);

  useEffect(() => {
    const data = robots.map(
      ({ serial, geo, managerId, managerName, managerTel }) => ({
        '로봇 시리얼': serial,
        아이디: managerId,
        보급처: managerName,
        전화번호: telNoFormats(managerTel),
        '보급 위치': geo.address.join(' '),
      }),
    );
    setData(XLSX.utils.json_to_sheet(data));
  }, [robots]);

  const handleDownload = () => {
    const wb = { Sheets: { [institution]: ws }, SheetNames: [institution] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(
      data,
      `${moment().format(
        'YYMMDDHHmmss',
      )}_${institution}_보급현황${fileExtension}`,
    );
  };

  return (
    <TableBox
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'scroll',
        display: 'flex',
        flexFlow: 'column',
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Button
        variant="contained"
        color="secondary"
        size="small"
        onClick={handleDownload}
        sx={{ alignSelf: 'end', mb: 1 }}
      >
        다운로드
      </Button>
      <TableContainer component={TablePaper}>
        <StyledTable
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: 12, color: 'secondary.main' }}>
                로봇 시리얼
              </TableCell>
              <TableCell sx={{ fontSize: 12, color: 'secondary.main' }}>
                아이디
              </TableCell>
              <TableCell sx={{ fontSize: 12, color: 'secondary.main' }}>
                보급처
              </TableCell>
              <TableCell sx={{ fontSize: 12, color: 'secondary.main' }}>
                전화번호
              </TableCell>
              <TableCell sx={{ fontSize: 12, color: 'secondary.main' }}>
                위치
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {robots.map(
              ({ serial, geo, managerId, managerName, managerTel }) => (
                <TableRow
                  key={serial}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {serial}
                  </TableCell>
                  <TableCell>{managerId}</TableCell>
                  <TableCell>{managerName}</TableCell>
                  <TableCell>{telNoFormats(managerTel)}</TableCell>
                  <TableCell>{geo.address.join(' ')}</TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableBox>
  );
};

export default SPSupplyTable;
